import { ChangeEventHandler, useContext, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import { UPLOAD } from 'apollo-client/mutations/uploadStock';
import { Button } from 'components/Button';
import { ModalContext } from 'providers/modal-provider';
import { PopupProps, STATUS } from 'components/Popup';

export const Uploader = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const { setModal } = useContext(ModalContext);
  const fileInput = useRef<HTMLInputElement>(null);

  const [upload] = useMutation(UPLOAD, {
    onError: (error) => {
      setModal<PopupProps>({
        type: 'Popup',
        props: {
          message: formatMessage({ id: 'error' }),
          status: STATUS.ERROR,
          details: error.message,
        },
      });
    },
    onCompleted: () => {
      setModal<PopupProps>({
        type: 'Popup',
        props: {
          message: formatMessage({ id: 'upload.success.title' }),
          details: formatMessage({ id: 'upload.success' }),
          status: 'SUCCESS',
        },
      });
    },
  });

  function onChange({
    target: {
      validity,
      files: [file],
    },
  }: {
    target: {
      validity: {
        valid: boolean;
      };
      files: FileList;
    };
  }): void {
    validity?.valid && upload({ variables: { file } });
  }
  return (
    <>
      <input
        style={{ display: 'none' }}
        id="file"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ref={fileInput}
        onChange={onChange as ChangeEventHandler<HTMLInputElement>}
      />
      <Button onClick={(): void => fileInput?.current?.click()} big secondary>
        <FormattedMessage id="upload-stock" />
      </Button>
    </>
  );
};
